import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import {messages as M} from '../../constants/messages';
import classnames from 'classnames';
import styles from './styles.module.scss';
import markSuccess from 'common/assets/check-opacity.svg';
import markFail from 'common/assets/fail.svg';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#root');

const DELAY = 1000;

const style = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    zIndex: 99999
  }
};



const PopupMessage = ({
                        hideLittlePopup,
                        display,
                        message
                      }) => {
  useEffect(() => {
    if (display) {
      setTimeout(() => {
        hideLittlePopup();
      }, DELAY);
    }
  }, [display]);

  return (
      <Modal
        isOpen={display}
        onRequestClose={hideLittlePopup}
        className={classnames(styles.popupModalContainer, (message !== M.FAILED) ? styles.popupMessageContainerSuccess : styles.popupMessageContainerFailed)}
        style={style}
      >
        <div className={styles.popupMessageContainer}>
          <div>{message}</div>
          {message !== M.FAILED
            ?
            <img
              src={markSuccess}
              alt="success-icon"
              className={styles.markSuccess}
            />
            :
            <img
              src={markFail}
              alt="fail-icon"
              className={styles.markFail}
            />
          }
        </div>
      </Modal>
  );
};

PopupMessage.propTypes = {
  hideLittlePopup: PropTypes.func,
  display: PropTypes.bool,
  message: PropTypes.string
};

export default PopupMessage;
